import '@fontsource/roboto-mono';
import { styled, Typography } from '@healthinal/ui';

export const TabularNumbers = styled(Typography)`
  font-variant-numeric: tabular-nums;
`;
